import React, { useId } from "react";

function GoldStar({ width = "20px", className = "" }) {
  const id = useId();
  const gradientId = `gold-star-gradient-${id}`;

  return (
    <svg
      width={width}
      height={width}
      className={className}
      viewBox='0 0 26 25'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M18.7406 23.9307L13.4406 21.1089C13.0316 20.8973 12.5345 20.8814 12.1271 21.1137L6.81217 23.8856C5.76687 24.4222 4.55661 23.5388 4.76538 22.3837L5.80878 16.4844C5.89583 16.0224 5.73439 15.5613 5.41365 15.225L1.13813 11.0144C0.300814 10.1829 0.774859 8.76051 1.92803 8.59647L7.87134 7.75784C8.33258 7.68511 8.73979 7.3995 8.93354 6.99036L11.6119 1.61775C12.1406 0.568109 13.6317 0.580402 14.1502 1.6262L16.7793 7.01488C16.9761 7.44034 17.3854 7.72297 17.8472 7.79231L23.779 8.6762C24.9334 8.84955 25.4002 10.2862 24.5511 11.0884L20.2353 15.2595C19.8993 15.5804 19.7413 16.0604 19.8139 16.5041L20.7941 22.4138C20.9936 23.5673 19.772 24.4419 18.7405 23.8952L18.7406 23.9307Z'
        fill={`url(#${gradientId})`}
      />
      <path
        opacity='0.52'
        d='M6.9002 14.9884C6.75716 14.7048 6.57875 14.4568 6.34715 14.2268L3.55029 11.4847C3.26524 11.2016 3.15719 10.7758 3.28 10.3847C3.40282 9.99356 3.73903 9.70821 4.14709 9.65344L8.01467 9.10653C8.91947 8.97891 9.71615 8.40775 10.1214 7.58941L11.8658 4.08477C12.042 3.71122 12.414 3.49676 12.8222 3.49526C13.2305 3.49377 13.6041 3.72325 13.7829 4.0955L14.6593 5.88581L14.3935 6.01109L13.5171 4.22078C13.3919 3.95487 13.1251 3.79603 12.8233 3.79714C12.5216 3.79825 12.2736 3.95897 12.1326 4.22585L10.3882 7.7305C9.92999 8.63781 9.06251 9.26251 8.05127 9.40828L4.1837 9.95518C3.88207 9.9918 3.65204 10.188 3.56433 10.4724C3.47662 10.7569 3.54873 11.0585 3.76245 11.253L6.55931 13.9952C6.80872 14.2429 7.00501 14.5263 7.16587 14.8276L6.90014 14.9706L6.9002 14.9884Z'
        fill='white'
      />
      <path
        opacity='0.52'
        d='M7.44283 21.8228C7.24758 21.8235 7.052 21.7354 6.89179 21.6117C6.55363 21.3643 6.39239 20.9565 6.46196 20.5656L6.98365 17.6159L7.2856 17.6681L6.7639 20.6177C6.71176 20.9198 6.81924 21.1858 7.06839 21.3624C7.31754 21.5391 7.61936 21.5557 7.88515 21.4305L11.3576 19.6242C12.2434 19.1593 13.344 19.173 14.2332 19.6314L17.6835 21.4656C17.9503 21.6067 18.2519 21.5878 18.4998 21.4093C18.7476 21.2308 18.8531 20.9463 18.8166 20.6623L18.1811 16.7935C18.0177 15.7819 18.3512 14.7685 19.0764 14.0556L21.8887 11.3283C22.1009 11.1145 22.1709 10.8301 22.0811 10.5463C21.9913 10.2625 21.7598 10.068 21.4578 10.0158L17.5861 9.42628C17.1777 9.3745 16.8044 9.23381 16.4664 9.02196L16.6251 8.75501C16.9454 8.94917 17.2831 9.07224 17.6383 9.12421L21.51 9.71378C21.9185 9.78331 22.239 10.0485 22.3647 10.4565C22.4904 10.8467 22.3677 11.2733 22.0848 11.5585L19.2725 14.2857C18.618 14.9274 18.3019 15.8519 18.4649 16.7392L19.1004 20.608C19.1729 21.0162 18.9968 21.4075 18.6605 21.6573C18.3241 21.8894 17.8982 21.9265 17.5247 21.7325L14.0744 19.8984C13.2741 19.4751 12.28 19.461 11.4828 19.8901L8.01038 21.6964C7.8332 21.7858 7.6204 21.8399 7.42508 21.8228L7.44283 21.8228Z'
        fill='white'
      />
      <defs>
        <linearGradient
          id={gradientId}
          x1='2.47353'
          y1='11.3681'
          x2='23.8284'
          y2='12.5416'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#BD9230' />
          <stop offset='1' stopColor='#F0C768' />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default GoldStar;
